import React from 'react';
import classnames from 'classnames';

// Types
import { ReviewTemplateVersion } from 'Shared/types/ReviewTemplates.type';
import { FormTypeType } from 'Shared/types/ReviewFormTemplate.type';

// Utils
import * as ReviewsUtils from 'Shared/utils/Reviews.utils';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';
import * as ReviewFormHelpers from 'Shared/model_helpers/ReviewForm.helper';
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

//Components
import { WpText } from 'Wpds/components/text';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import ReviewForm from '../ThreeSixtyReviewPartials/ReviewForm/ReviewForm';
import { useReview } from 'Shared/utils/hooks/use-review';

// Styles
import './SelfReviewContainer.scss';

type Props = {
  review;
  inContainer?: boolean;
  showTitle?: boolean;
};

const SelfReviewContainer = ({ review, showTitle = true, inContainer = true }: Props) => {
  const reviewSlug = ReviewsHelpers.getSlug(review);

  const { selfPeerReviewForm: selfReviewForm, reviewTemplateVersion } = useReview({ slug: reviewSlug });

  const selfReviewTemplateV1 = ReviewsUtils.getFormTemplateForForm({
    review,
    templateFormType: FormTypeType.peer_review,
  });
  const selfReviewTemplateV2 = ReviewsUtils.getFormTemplateForForm({
    review,
    templateFormType: FormTypeType.self_peer_review,
  });

  const selfReviewFormAnswers = ReviewFormHelpers.getAnswers(selfReviewForm);
  const selfReivewFormSubmittedAt = ReviewFormHelpers.getSubmittedAt(selfReviewForm);
  const selfReviewFormData = ReviewFormHelpers.getFormData(selfReviewForm);
  const selfReviewQuestions = ReviewFormTemplatesHelpers.getQuestions(
    reviewTemplateVersion === ReviewTemplateVersion.one ? selfReviewTemplateV1 : selfReviewTemplateV2
  );
  const selfReviewFormSlug = ReviewFormHelpers.getSlug(selfReviewForm);

  const reviewForm = (
    <ReviewForm
      questions={selfReviewQuestions}
      answers={selfReviewFormAnswers?.toJS()}
      formData={selfReviewFormData}
      formSlug={selfReviewFormSlug}
    />
  );

  // if the receiver did not complete do the self_peer_review form
  // do not try and render it
  if (!selfReivewFormSubmittedAt) return null;
  const baseClassName = 'SelfReviewContainer';
  const clssses = classnames(baseClassName, {
    [`${baseClassName}--v2`]: reviewTemplateVersion === ReviewTemplateVersion.two,
  });

  return (
    <>
      {showTitle && (
        <WpText tag="h5" variant="bodyXl" bold>
          Self Review
        </WpText>
      )}
      {inContainer ? (
        <WpContainer className={clssses}>
          <WpContainerBody>{reviewForm}</WpContainerBody>
        </WpContainer>
      ) : (
        reviewForm
      )}
    </>
  );
};

export default SelfReviewContainer;
